import { useDictionary, OrderStates } from "@adamlip/okeoke.client"
import { MainContext } from "contexts/MainContext"
import { useContext } from "react"
import useBasket from "hooks/useBasket"
import { AppParamsContext } from "contexts/AppParamsContext"

export default function BasketValueIcon() {
  const { appParams } = useContext(AppParamsContext)
  const { handleClickCart } = useContext(MainContext)
  const { getValue } = useDictionary()
  const { itemCount, orderState, discountPrice } = useBasket()

  return (
    <div
      className={`transition-colors flex flex-col shrink-0 gap-1 h-full cursor-pointer`}
      onClick={() => handleClickCart()}
    >
      <div
        className={`mx-auto ${
          appParams?.styles?.borderRadius?.navBar || "rounded-full"
        } text-[var(--bottom-bar-text-color)]`}
      >
        <div style={{ fontSize: "11px" }} className="text-center">
          {getValue("app_v2_topBar_cartText")}
        </div>
        <div className="flex text-sm justify-center font-bold">
          <span className="mr-1">
            {itemCount > 0 && orderState === OrderStates.BASKET
              ? discountPrice
              : 0}
          </span>
          <span className="">Ft</span>
        </div>
      </div>
    </div>
  )
}

// <div
//   className={`text-sm text-center truncate ${
//     size != null ? textMax?.[size] : "max-w-[55px]"
//   }`}
// >
//   {getValue("app_v2_topBar_cartText")}
// </div>
